import styles from './GiftCard.module.scss';

import React from 'react';
import cx from 'clsx';

import { GIFT_CARD_IMG_URL, GIFT_CARD_TEST_ID } from 'components/GiftCard/GiftCardConsts.js';

type GiftCardProps = React.HTMLAttributes<HTMLDivElement> & Readonly<{
  cardBackgroundImageUrl?: string;
  amount?: number;
  children?: never;
}>;

export const GiftCard: React.FC<GiftCardProps> = ({ cardBackgroundImageUrl, className, amount, ...props }) => (
  <div data-testid={GIFT_CARD_TEST_ID} className={cx(styles.cardContainer, className)} {...props}>
    <div className={styles.card} style={{ backgroundImage: `url(${cardBackgroundImageUrl ?? GIFT_CARD_IMG_URL})` }}>
      {amount && <span className={styles.amount}>${amount}</span>}
    </div>
  </div>
);
